export default __webpack_public_path__ + "static/media/vendors-sample-management.6913612d.png";